export class ToggleLoadingOn {
	static readonly type = '[loading modal state] setting loading state on';
	constructor(
		public title: string,
		public subtitle: string,
	) {}
}

export class ToggleLoadingOff {
	static readonly type = '[loading modal state] setting loading state off';
	constructor(public timeBufferMS?: number) {}
}
